import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// PAGINA 9 — Capitulos XII (Gimnasio, condicional) + XIII (Jardines, condicional).
// Si ambos estan apagados, esta pagina no debe renderizarse (controlado por buildPagesList).
export default function GimnasioJardinesPage({ config, pagNum, pagTotal, capRomanoMap }) {
  const verGim = !!config.capitulosVisibles.gimnasio;
  const verJard = !!config.capitulosVisibles.jardines;
  const secNum = String(pagNum - 2).padStart(2, "0");
  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Amenities (1)</span>
        <h2 className="big">
          {verGim && verJard ? <>Gimnasio y <em>exteriores.</em></> : verGim ? <em>Gimnasio.</em> : <em>Jardines y exteriores.</em>}
        </h2>

        {verGim && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.gimnasio}</div>
              <h3 className="art-title">Gimnasio</h3>
            </div>
            <div className="hours-grid">
              {config.horarios.gimnasio.map((h) => (
                <div key={h.id} className="hours-card">
                  <div className="lbl">{h.lbl}</div>
                  <div className="val">{h.val}</div>
                  {h.note && <div className="note">{h.note}</div>}
                </div>
              ))}
            </div>
            <ol className="rules">
              <li><span className="m">a</span><span>Uso limitado a residentes. <b>Prohibido a menores de 12.</b></span></li>
              <li><span className="m">b</span><span>Vestir el equipo adecuado en todo momento.</span></li>
              <li><span className="m">c</span><span>No se aceptan animales.</span></li>
              <li><span className="m">d</span><span>Prohibido jugar con los aparatos o hacer ruidos innecesarios.</span></li>
              <li><span className="m">e</span><span>Uso por cuenta y riesgo: lesiones son <b>responsabilidad exclusiva</b>.</span></li>
              <li><span className="m">f</span><span>Roturas o mal uso: cobro de reparaciones o reposiciones.</span></li>
              <li><span className="m">g</span><span>Prohibido lucrar o dar clases.</span></li>
              <li><span className="m">h</span><span>El conserje hace valer el reglamento y puede pedir abandonar el gimnasio.</span></li>
            </ol>
          </div>
        )}

        {verJard && (
          <div className="art">
            <div className="art-head">
              <div className="art-num">Capítulo {capRomanoMap.jardines}</div>
              <h3 className="art-title">Jardines, aceras y exteriores</h3>
            </div>
            <p className="art-lede">
              Los jardines, plantas, elementos decorativos y de iluminación serán objeto del debido cuidado. <b>Está prohibido cortar flores o desgajar las plantas.</b>
            </p>
          </div>
        )}
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
